<template>
  <div class="checklist-amostra-lote">
    <g-card class="card-consultas" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho">
            Checklist de Amostra / Lote
          </div>
          <div class="header-icons">
            <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              @click="limpar"
            />
            <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="Grid()"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="consultar-checklist-conteudo espacamento-filtros">
          <div class="filtro-empresa">
            <div class="empresa titulo-conteudo-filtros">Unidade</div>
            <PDropDown
              class="cliente-input input-label unidade"
              v-model="objFiltros.UnidadeId"
              :options="UnidadeArray"
              optionLabel="nome"
              optionValue="id" 
              placeholder="TODAS"
              :filter="true"
            >
            </PDropDown>
          </div>

          <div class="filtro-cliente">
            <div class="cliente titulo-conteudo-filtros">Cliente</div>
            <!-- <PDropDown
              class="cliente-input input-label"
              placeholder="Selecione o cliente"
              :filter="true"
              optionLabel="nomeFantasia"
              optionValue="id"
              v-model="objFiltros.ClienteId"
              @filter="buscarClientes($event.value)"
              :filterFields="[
                'razaoSocial',
                'codigoExterno',
                'nomeFantasia',
                'situacao',
                'estadoCidade',
                'cnpj',
              ]"
              :options="ClienteArray"
            >
              <template #option="slotProps">
                <cliente-dropdown-item
                  :dadosCliente="slotProps.option"
                ></cliente-dropdown-item>
              </template>
            </PDropDown> -->
            <cliente-dropdown
                            class="cliente-input input-label"
                            v-model="objFiltros.ClienteId"
                            placeholder="Selecione o cliente"
                            :empresaId="objFiltros.UnidadeId"
                            :representanteId="objFiltros.RepresentanteId"
                        />
          </div>

          <div class="filtro-numero-formulario">
            <div class="numero-pedido titulo-conteudo-filtros">Nº do Formulário</div>
            <PInputText
              class="numero-pedido-input input-label"
              placeholder="Insira o Número"
              v-model="objFiltros.NumeroFormulario"
            />
          </div>

          <div class="filtro-numero-pedido">
            <div class="numero-pedido titulo-conteudo-filtros">Nº do Pedido</div>
            <PInputText
              v-model="objFiltros.CodigoPedido"
              class="numero-pedido-input input-label"
              placeholder="Insira o Número"
            />
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="15px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="Grid()"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card v-if="pt1" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!pt1" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Checklist de Amostra / Lote"
      altura="auto"
      :colunas="Colunas"
      :Paginacao="true"
      :valores="ChecklistArray"
      :NumeroLinhas="100"
      :Filtros="Filtro"
      :FiltrosEspecificos="true"
      :Imprimivel="true"
      :rowEditor="true"
      v-on:clickImprimir="imprimir"
      :campoAgrupador="'empresaCliente'"
      :campoExibicaoGrupo="'empresaCliente'"
      TextImprimir="Abrir PDF"
      ></g-data-table>
    </g-card>    
  </div>
  <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
    <div class="container-logo">
        <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
    </div>
    <div class="render" v-if="renderiza">
      <ChecklistAmostraLotePDF :tituloDetalhes="false" v-on:termino="gerarPdf" :checkListAmostraSelecionada="checkListId"></ChecklistAmostraLotePDF>
    </div>
  </g-pdf>
</template>


  <script>
import ChecklistAmostraLote from "./ChecklistAmostraLote.js";
export default ChecklistAmostraLote;
</script>

<style scoped>
.container-logo{
  padding: 30px 30px 10px 53px;
}
@media (min-width: 310px) {}

@media (min-width: 368px) {}

@media (min-width: 600px) {
.consultar-checklist-conteudo {
  display: grid;
  grid-template-columns: minmax(6em, 49%) minmax(6em, 49.5%);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
}

.filtro-unidade {
  grid-area: 1 / 1 / 2 / 2;
}
.filtro-cliente {
  grid-area: 1 / 2 / 2 / 3;
}
.filtro-numero-formulario {
  grid-area: 2 / 1 / 3 / 2;
}
.filtro-numero-pedido {
  grid-area: 2 / 2 / 3 / 3;
}
}

@media (min-width: 801px) {

}

@media (min-width: 1025px) {
  .consultar-checklist-conteudo {
    grid-template-columns: repeat(2, minmax(6em, 28em)) repeat(2,minmax(6em, 13em));
    grid-template-rows: auto;
  }
  .filtro-numero-formulario {
    grid-area: 1 / 3 / 2 / 4;
    width: 100%;
  }
  .filtro-numero-pedido {
    grid-area: 1 / 4 / 2 / 5;
    width: 100%;
  }
}

@media (min-width: 1281px) {}

@media (min-width: 1500px) {}
</style>